import React from 'react';
import logo from 'platform/assets/images/sd_one_blau.svg';
import './LoginLogo.scss';

const LoginLogo = () => <img className="LoginLogo" src={logo} alt="Logo" />;

export default LoginLogo;
